export { default } from './ToggleSwitchCore';
export type { ToggleSwitchCoreProps } from './ToggleSwitchCore';
